import type { BrandedFare } from '@/app/api/hotel-detail/branded-fares/route';

/**
 * Folds the selected branded fare's package price into a mealPlan-shaped object so
 * every price component (headline, total, taxes breakdown) reads one consistent value.
 *
 * Only finalPrice / finalTotalPrice are overridden — priceWithoutTaxes / excludedCharges
 * stay at the base mealPlan, exactly as checkout's getUpdatedMealPlan does. Both the
 * branded-fare price and its package total are already fetched client-side via
 * useBrandedFares, so this needs no network call.
 */
export function mergeBrandedFareIntoMealPlan(
  mealPlan: MealPlanType,
  selectedBrandedFare: BrandedFare | undefined
): MealPlanType {
  return {
    ...mealPlan,
    finalPrice: selectedBrandedFare?.finalPrice || mealPlan.finalPrice,
    finalTotalPrice: selectedBrandedFare?.finalTotalPrice || mealPlan.finalTotalPrice,
  };
}
